import React from 'react';
import tapColors from '../../resources/tapColors';
import AccordianSection from './accordian-section';
import StatRow from '../bitsnbobs/statrow';
import parse from 'html-react-parser';
import './accordian.scss';
import esriStrings from '../../resources/esriStrings';

const Accordian = (props) => {
  const handleClick = (key) => {
    props.handleSection(key);
    props.onWidget();
  };

  return <div className="accordian-content">
    {props.data.length ? props.data.map((seg, idx) => {
      if (seg.details) {
        const color = tapColors[parseInt(seg.details.tapseg)];
        const key = `${seg.details.tapseg}_${idx}`;
        const isActive = props.activeSection === key;
        if (!props.activeSection && idx === 0) {
          props.handleSection(key);
        }
        const stats = [
          {
            value: seg.details.median_age,
            label: esriStrings.medianAge
          },
          {
            value: seg.details.avg_hh_size,
            label: esriStrings.housholdSize
          },
          {
            value: seg.details.diversity_idx,
            label: esriStrings.diversityIdx
          }
        ];

        return (
          <AccordianSection
            key={idx}
            idx={idx}
            isActive={isActive}
            textColor={color}
            sectionKey={key}
            title={seg.details.segNameShort}
            preTitle={`${seg.percentage}% `}
            handleClick={handleClick}
          >
            <StatRow stats={stats}></StatRow>
            <div className="accordian-content-bodytext clean-scrollbars">
              <div>
                {parse(seg.details.Description)}
                <a
                data-event="track-component"
                data-component-name={'Tapestry Segment Details'}
                data-component-link={`Link to pdf for ${props.title}`}
                data-component-link-placement="1"
                data-component-link-type="title"
                target="_blank" href={seg.details.url}>
                  {' '}
                  <b>Learn More</b>
                </a>
              </div>
            </div>
          </AccordianSection>
        );
      }

      return null;
    }) : <div className = "no-data-wrapper"><h1 className = "no-data">No Segmentation Data Available</h1></div>}
  </div>;
}
;

export default Accordian;
